// extracted by mini-css-extract-plugin
export default {"projectsText":"add-to-project--projectsText","existingProject":"add-to-project--existingProject"};